import React, { FC } from 'react';
import { CONTENT_TYPE_PRODUCT_SUB_FAQ } from '@/core/constants';
import {
  TypeImage,
  TypeImageFields,
  TypeTextBlock,
  TypeTextBlockFields,
} from '@/core/generated-types';
import { TextBlock } from '../TextBlock';
import { Image } from '@/components/ui/Image';

interface ProductSubFAQInterface {
  entries: TypeImage[] | TypeTextBlock[];
}

const ProductSubFAQ: FC<ProductSubFAQInterface> = ({ entries }) => {
  return (
    <ul className="flex flex-row gap-8" data-testid="product-badges-awards">
      {entries?.map((entry: TypeImage | TypeTextBlock) => {
        const { sys, fields } = entry;
        const { id: componentType } = sys.contentType.sys;

        // can be 'image' or 'textBlock'. They shouldn't be mixed.
        switch (componentType) {
          case CONTENT_TYPE_PRODUCT_SUB_FAQ.IMAGE:
            const imageFields = fields as TypeImageFields;
            return (
              <li key={sys.id}>
                <Image
                  imageData={entry as TypeImage}
                  height={120}
                  width={120}
                  alt={imageFields?.altText}
                />
              </li>
            );
          case CONTENT_TYPE_PRODUCT_SUB_FAQ.TEXTBLOCK:
            return (
              <li key={sys.id}>
                <TextBlock {...(fields as TypeTextBlockFields)} />
              </li>
            );
        }
      })}
    </ul>
  );
};

export default React.memo(ProductSubFAQ);
